export default __webpack_public_path__ + "static/media/car-fixing-1.f36d8444.jpg";